import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Spin, Result } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import './CallbackPage.css';
// import { BASE_URL } from '../utility/constants';

/**
 * OIDC Callback page to handle tokens returned in URL fragment
 */
const CallbackPage = () => {
  const { setUser, setError } = useAuth();
  const history = useHistory();
  const location = useLocation();
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the hash fragment from the URL
        const hash = location.hash.substring(1); // Remove the '#' character
        const params = new URLSearchParams(hash);
        
        // Extract tokens from the fragment
        const accessToken = params.get('access_token');
        const idToken = params.get('id_token');
        const tokenType = params.get('token_type');
        const expiresIn = params.get('expires_in');
        const state = params.get('state');
        
        console.log('OIDC Callback - Tokens received:', {
          accessToken: accessToken ? 'present' : 'missing',
          idToken: idToken ? 'present' : 'missing',
          tokenType,
          expiresIn,
          state
        });

        if (accessToken && idToken) {
          // Store tokens in session storage
          sessionStorage.setItem('access_token', accessToken);
          sessionStorage.setItem('id_token', idToken);
          sessionStorage.setItem('token_type', tokenType || 'Bearer');
          if (expiresIn) {
            sessionStorage.setItem('token_expires_in', expiresIn);
            // Calculate expiry time
            const expiryTime = Date.now() + (parseInt(expiresIn) * 1000);
            sessionStorage.setItem('token_expiry', expiryTime.toString());
          }
          console.log('Tokens stored in session storage');
          
          // Redirect to admin after successful token storage
          history.replace('/admin');
        } else {
          // Handle error case
          console.error('Missing tokens in callback');
          history.replace('/auth?error=missing_tokens');
        }
      } catch (error) {
        console.error('Error handling OIDC callback:', error);
        history.replace('/auth?error=callback_error');
      }
    };

    handleCallback();
  }, [location, history, setUser, setError]);

  return (
    <div className="callback-container">
      <div className="callback-content">
        <Spin size="large" />
        <Result
          status="info"
          title="Processing Authentication"
          subTitle="Please wait while we complete your sign-in..."
        />
      </div>
    </div>
  );
};

export default CallbackPage; 